import { useMemo } from 'react';
import { normalizeProperty } from '../../utils/normalizeProperty';
import useGetAdditionalPropertyValueProxy from './useGetAdditionalPropertyValueProxy';
import { useNormalizeObjectTypeId } from './useNormalizeObjectTypeId';
import { usePatchedProperty } from './usePatchedProperty';
/**
 * This hook serves as a normalization layer for the PropertyInputV2 component. In order to
 * support the legacy usages of our external API, without halting the migration to the new
 * API, we normalize some data to a standard format that our internal components expect.
 */
export const usePropertyInputNormalization = ({
  getAdditionalPropertyValue,
  getDraftValue,
  getSavedValue,
  objectTypeId,
  property
}) => {
  const normalizedObjectTypeId = useNormalizeObjectTypeId({
    objectTypeOrId: objectTypeId,
    componentName: 'PropertyInputV2'
  });
  const normalizedProperty = useMemo(() => normalizeProperty(property), [property]);
  const patchedProperty = usePatchedProperty({
    property: normalizedProperty,
    objectTypeId: normalizedObjectTypeId
  });
  const getAdditionalPropertyValueProxy = useGetAdditionalPropertyValueProxy({
    getAdditionalPropertyValue,
    getDraftValue,
    getSavedValue,
    objectTypeId: normalizedObjectTypeId,
    propertyName: patchedProperty.name,
    componentName: 'propertyinputv2'
  });
  return {
    normalizedObjectTypeId,
    normalizedProperty: patchedProperty,
    normalizedGetAdditionalPropertyValue: getAdditionalPropertyValueProxy
  };
};